import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import Markdown from "markdown-to-jsx";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import "../LaunchComponent/LaunchDataDisplay.css";
import NudgeSubmissionPop from "./nudgeSubmissionPop";
const NudgeDataDisplay = ({
 mailerParent,
 mailerChild,

 setIsNudgeGenerationClicked,
 categoryNameNudge,

 handleReset,
 setIsNudgeNavigatedToForm,
 setIsNudgeMailGenerated,
 programNameNudge,
}) => {
 const [open, setOpen] = useState(false);
 const isSubmitted = useSelector((state) => state.model.isSubmitted);
 const isNudegeLoaded = useSelector((state) => state.nudge.isNudgeLoaded);

 const nudgeMail = useSelector((state) => state.nudge.nudgeMail);
 console.log("nudgemail", nudgeMail);
 return (
  <>
   <div className="data-display-new">
    <div className="result-container">
     <div className="result-wrap">
      <div className="result-content">
       {!isNudegeLoaded && (
        <Box
         display="flex"
         flexDirection="column"
         alignItems="center"
         sx={{
          height: "100%",
          justifyContent: "center",
         }}
        >
         <CircularProgress />
         <Typography variant="h6" marginTop={2}>
          Generating...
         </Typography>
        </Box>
       )}
       {isNudegeLoaded && nudgeMail != "" && (
        <Stack spacing={2} sx={{ padding: "0px", background: "white" }}>
         <style>
          {`
                    .highlight {
                        font-weight: bold;
                        color: black;
                    }
                `}
         </style>

         <div style={{ overflowY: "scroll", border: "0px !important" }}>
          <Markdown>{nudgeMail}</Markdown>
         </div>
        </Stack>
       )}
      </div>
      <div className="result-btn-container">
       <div className="result-left">
        {isNudegeLoaded && (
         <Button
          variant="outlined"
          sx={{ marginRight: "10px" }}
          disabled={isSubmitted ? true : false}
          onClick={() => {
           setOpen(true);
          }}
         >
          Submit For Approval
         </Button>
        )}
       </div>
       <div className="result-right">
        <img src={process.env.PUBLIC_URL + "/Images/Dislikeicon.png"} />
        <img src={process.env.PUBLIC_URL + "/Images/Likeicon.png"} />
       </div>
      </div>
     </div>
     <div className="return-wrap">
      <p
       onClick={() => {
        setIsNudgeGenerationClicked(false);
        // dispatch(handleTeaserLoading());
        setIsNudgeNavigatedToForm(true);
        setIsNudgeMailGenerated(null);
       }}
      >
       {"<"} Back
      </p>
     </div>
     <NudgeSubmissionPop
      open={open}
      setOpen={setOpen}
      mailerParent={mailerParent}
      mailerChild={mailerChild}
      modalResponse={nudgeMail}
      categoryNameNudge={categoryNameNudge}
      handleReset={handleReset}
      programNameNudge={programNameNudge}
     />
    </div>
   </div>
  </>
 );
};

export default NudgeDataDisplay;
